import { render, staticRenderFns } from "./MessageContextMenu.vue?vue&type=template&id=eb813b70&scoped=true&"
import script from "./MessageContextMenu.vue?vue&type=script&lang=js&"
export * from "./MessageContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessageContextMenu.vue?vue&type=style&index=0&id=eb813b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb813b70",
  null
  
)

export default component.exports